import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import resize from '../resize';
Swiper.use([Pagination, Navigation, Lazy]);

const initResumeSlider = () => {
  const sliderContainer = document.querySelector('.resume-right__swiper');
   
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(sliderContainer, {
        breakpoints: {
          0: {
            slidesPerView: 2.6,
            spaceBetween: 12,
          },
        },
      });
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth < 1024 ? init() : destroy();
  }

  sliderContainer && resizeSwiper();
  sliderContainer && resize(resizeSwiper);
};

export default initResumeSlider;
